import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModal } from 'apps/auth/actions/appAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';

import SecurityCloseAccountForGa from './SecurityCloseAccountForGa';

const SecurityPopupMenu = ({ popupRef = null, ...props }) => {
    const onClickHandlerForGaUser = (e) => {
        e.preventDefault();
        popupRef.current?.close();
        props.toggleModal(true, <SecurityCloseAccountForGa />, false);
    };
    const linkForGaUsers = <PopupButton iconName="cross" text={props.securityDeactivateTitle} onClick={onClickHandlerForGaUser} />;
    const linkForOtherUsers = <PopupButton href="/auth/security/deactivate/account" iconName="cross" text={props.securityDeactivateTitle} />;

    return (
        <SimplePopup withoutBorder popupRef={popupRef}>
            {props.gaUser ? linkForGaUsers : linkForOtherUsers}
        </SimplePopup>
    );
};
const mapStateToProps = (state) => {
    return {
        securityDeactivateTitle: state.messages.pageMessages.securityDeactivateTitle,
        securityCancel: state.messages.pageMessages.securityCancel,
        gaUser: state.extra.gaUser,
    };
};
SecurityPopupMenu.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

export default connect(mapStateToProps, { toggleModal })(SecurityPopupMenu);
